var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import classNames from 'classnames';
import { defaultProps } from './defaults';
import { DivTag, UlTag, LiTag } from '../../Utils/AtomicTag';
var DateMonthPicker = /** @class */ (function (_super) {
    __extends(DateMonthPicker, _super);
    function DateMonthPicker(props) {
        var _this = _super.call(this, props) || this;
        _this.getMonth = function () {
            return Array.from(Array(12), function (v, k) {
                return k + 1;
            });
        };
        _this.getYears = function (type) {
            var currYear = _this.state.currYear;
            var newCurrYear = Number(currYear) + (type === 'prev' ? -1 : 1);
            _this.setState({
                currYear: newCurrYear < 100 ? 100 : newCurrYear,
            });
        };
        var year = _this.props.year;
        _this.state = {
            currYear: year,
            months: _this.getMonth(),
        };
        return _this;
    }
    DateMonthPicker.prototype.render = function () {
        var contentCls = ['font-sans', 'bg-white', 'flex', 'flex-col'];
        var yearWrapCls = [
            'flex',
            'flex-1',
            'border-gray-200',
            'items-center',
            'justify-between',
            'flex-wrap',
        ];
        var yearCls = [];
        var currMonth = new Date().getMonth() + 1;
        var _a = this.props, month = _a.month, updateMonth = _a.updateMonth, monthCellRender = _a.monthCellRender, monthFullCellRender = _a.monthFullCellRender;
        var _b = this.state, months = _b.months, currYear = _b.currYear;
        return (React.createElement(DivTag, { name: DateMonthPicker.NAME, atomics: contentCls },
            React.createElement(UlTag, { atomics: yearWrapCls, className: "month-ul" }, months.map(function (monthItem) {
                return (React.createElement(LiTag, { atomics: yearCls, key: monthItem, className: classNames('month-li', {
                        'month-li-selected': monthItem === Number(month),
                        'month-li-curr': monthItem === currMonth,
                    }), onClick: function () { return updateMonth(currYear, monthItem); } }, monthFullCellRender
                    ? monthFullCellRender(monthItem)
                    : monthItem + "\u6708" + (monthCellRender ? monthCellRender(monthItem) : '')));
            }))));
    };
    DateMonthPicker.defaultProps = defaultProps;
    DateMonthPicker.NAME = 'date-month-picker';
    return DateMonthPicker;
}(Component));
export { DateMonthPicker };
